import React from 'react';
import { getImagePathByMarketKey } from "../../../services/bet-finder-service";
import { defaultBookmakers } from '../../../constants';
import { getSourceTypeForBookmaker, SOURCE_BADGE_COLORS, SOURCE_SHORT_LABELS } from '../../../utils/source-type';
import { getBookieLinkProps } from '../../../utils/bookie-app-links';

const bookiePromotions: Record<string, string> = {
  "fanduel": "FanDuel - Bet $5, Get $200 in Bonus Bets",
  "williamhill_us": "Caesars - Get up to $1,000 Back in Bonus Bets if Your First Bet Doesn't Win!",
  "lowvig": "LowVig.ag",
  "betonlineag": "BetOnline.ag",
  "wynnbet": "WynnBET",
  "betus": "BetUS",
  "superbook": "SuperBook",
  "mybookieag": "MyBookie.ag",
  "betmgm": "BetMGM",
  "pointsbetus": "PointsBet (US)",
  "twinspires": "TwinSpires",
  "betrivers": "BetRivers",
  "unibet_us": "Unibet",
  "bovada": "Bovada",
  "barstool": "Barstool Sportsbook",
  "draftkings": "DraftKings",
  "gtbets": "GT Bets", 
  "sugarhouse": "Sugar House", 
  "circasports": "Circa Sports", 
  "betfair": "BetFair", 
  "foxbet": "FoxBet",
  "pikkit":"Pikkit",
  "espnbet":"theScore Bet",
  "ballybet":"BallyBet",
  "betparx":"BetParx",
  "fliff":"Fliff",
  "hardrockbet":"Hard Rock Bet",
  "tipico_us":"Tipico",
  "sisportsbook":"SI Sportsbook",
  "windcreek":"WindCreek",
  "dabble":"Dabble",
  "dabble_au":"Dabble",
  "pointsbetau":"PointsBet AU",
  "sportsbet":"Sportsbet",
  "ladbrokes_au":"Ladbrokes AU",
  "neds":"Neds",
  "tab":"TAB",
  "tabtouch":"TABtouch",
  "unibet":"Unibet",
  "betr_au":"Betr AU",
  "betright":"BetRight",
  "playup":"PlayUp",
  // DFS / Pick'em
  "prizepicks":"PrizePicks",
  "underdog":"Underdog Fantasy",
  "pick6":"DraftKings Pick6",
  "betr_us_dfs":"Betr Picks",
  // Exchanges
  "novig":"Novig",
  "prophetx":"ProphetX",
  "betopenly":"BetOpenly",
  "matchbook":"Matchbook",
  // Prediction Markets
  "kalshi":"Kalshi",
  "polymarket":"Polymarket",
  // EU/AU Exchanges
  "betfair_ex_eu":"Betfair Exchange",
  "betfair_ex_au":"Betfair Exchange AU",
};


export const bookieSignUpLinks: { [key: string]: string } = {
  "williamhill_us": "https://caesars.com/sportsbook-and-casino/referral?AR=RAF-0D6-NYC",
  "lowvig": "https://sportsbook.lowvig.ag",
  "betonlineag": "https://www.betonline.ag",
  "wynnbet": "https://www.wynnbet.com",
  "betus": "https://www.betus.com.pa",
  "superbook": "https://www.superbook.com",
  "mybookieag": "https://www.mybookie.ag",
  "fanduel": "https://fndl.co/7s5utjf",
  "betmgm": "https://sports.betmgm.com",
  "pointsbetus": "https://pointsbet.com",
  "twinspires": "https://www.twinspires.com",
  "betrivers": "https://www.betrivers.com",
  "unibet_us": "https://www.unibet.com",
  "bovada": "https://www.bovada.lv",
  "barstool": "https://barstoolsportsbook.com",
  "draftkings": "https://sportsbook.draftkings.com",
  "gtbets": "https://www.gtbets.ag/", 
  "sugarhouse": "https://playsugarhouse.com/", 
  "circasports": "https://www.circasports.com/", 
  "betfair": "https://www.betfair.com/",
  "foxbet": "", 
  "espnbet":"https://espnbet.com/",
  "pikkit": "https://links.pikkit.com/invite/basketball49080", 
  "ballybet":"https://www.ballybet.com/",
  "betparx":"https://www.betparx.com/",
  "fliff":"https://get.fliffapp.com/QlC3/h630rubi",
  "hardrockbet":"https://www.hardrock.bet/",
  "tipico_us":"https://www.tipico.com/us",
  "sisportsbook":"https://www.sisportsbook.com/",
  "windcreek":"",
  "dabble":"https://www.dabble.com.au/",
  "dabble_au":"https://www.dabble.com.au/",
  "pointsbetau":"https://pointsbet.com.au/",
  "sportsbet":"https://www.sportsbet.com.au/",
  "ladbrokes_au":"https://www.ladbrokes.com.au/",
  "neds":"https://www.neds.com.au/",
  "tab":"https://www.tab.com.au/",
  "tabtouch":"https://www.tabtouch.com.au/",
  "unibet":"https://www.unibet.com.au/",
  "betr_au":"https://www.betr.com.au/",
  "betright":"https://www.betright.com.au/",
  "playup":"https://www.playup.com/",
  "parlayplay":"https://parlayplay.io/",
  "thrillzz":"https://thrillzz.com/",
  "rebet":"https://rebet.app/",
  // DFS / Pick'em
  "prizepicks":"https://www.prizepicks.com/",
  "underdog":"https://underdogfantasy.com/",
  "pick6":"https://pick6.draftkings.com/",
  "betr_us_dfs":"https://www.betr.app/",
  // Exchanges
  "novig":"https://www.novig.com/",
  "prophetx":"https://www.prophetx.co/",
  "betopenly":"https://www.betopenly.com/",
  "matchbook":"https://www.matchbook.com/",
  // Prediction Markets
  "kalshi":"https://kalshi.com/",
  "polymarket":"https://polymarket.com/",
  // EU/AU Exchanges
  "betfair_ex_eu":"https://www.betfair.com/exchange",
  "betfair_ex_au":"https://www.betfair.com.au/exchange",
};



function resolveBookieKey(bookie: string): string {
  if (!bookie) return "";
  if (bookie.includes("hardrock") || bookie.includes("hard_rock")) return "hardrockbet";
  if (bookie.toLowerCase().includes("dabble")) return "dabble_au";
  if (bookiePromotions[bookie]) return bookie;
  return bookie;
}

const BookieImageBase = ({
  bookie,
  margin = true,
  showSourceBadge = false,
  asLink = true,
  inlineBadge = false,
}: {
  bookie: string;
  margin?: boolean;
  showSourceBadge?: boolean;
  /** When false, render the logo (+badge) WITHOUT the <a> wrapper — needed
   *  when this sits inside another anchor (e.g. the deeplink chip) so we
   *  don't nest <a> in <a> (invalid HTML). */
  asLink?: boolean;
  /** Render the source badge inline (a small tag after the logo) instead of
   *  the absolute corner overlay, so it can't overflow its container. */
  inlineBadge?: boolean;
}) => {
  if (!bookie) return null;
  const imagePath = getImagePathByMarketKey(bookie);
  const resolved = resolveBookieKey(bookie);
  const sourceType = getSourceTypeForBookmaker(bookie);
  const badgeColor = SOURCE_BADGE_COLORS[sourceType];
  const badgeLabel = SOURCE_SHORT_LABELS[sourceType];
  const title = bookiePromotions[resolved] || defaultBookmakers.find(b => b.key === bookie)?.title;

  const linkProps = getBookieLinkProps(resolved);

  const img = (
    <img
      src={imagePath}
      alt={bookie}
      // Hundreds of these render across the board. Lazy + async decode keeps
      // them off the critical scroll path, and explicit width/height stops
      // per-image layout shift (a cause of blank repaints on fast scroll).
      loading="lazy"
      decoding="async"
      width={27}
      height={27}
      className="rounded"
      style={{
        borderRadius: '0.25rem',
        height: '27px',
        width: '27px',
        maxWidth: '57px',
        maxHeight: '57px',
        display: 'block',
      }}
    />
  );

  // The logo, optionally wrapped in its own homepage link.
  const logo = asLink ? (
    <a {...linkProps} title={title} style={{ display: 'inline-block' }}>
      {img}
    </a>
  ) : (
    img
  );

  const inlineBadgeEl = showSourceBadge && badgeLabel && inlineBadge && (
    <span
      className={`${badgeColor} text-white text-[7px] font-bold px-0.5 rounded leading-tight`}
      style={{ lineHeight: '1.2', flexShrink: 0 }}
    >
      {badgeLabel}
    </span>
  );

  const cornerBadgeEl = showSourceBadge && badgeLabel && !inlineBadge && (
    <span
      className={`${badgeColor} text-white absolute -bottom-1 -right-1 text-[7px] font-bold px-0.5 rounded leading-tight`}
      style={{ lineHeight: '1.2' }}
    >
      {badgeLabel}
    </span>
  );

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: inlineBadge ? '4px' : undefined,
        position: 'relative',
        marginRight: margin ? '8px' : '',
      }}
    >
      {logo}
      {inlineBadgeEl}
      {cornerBadgeEl}
    </span>
  );
};

// Memoized: a single board paints hundreds of logos and their props
// (bookie key / flags) are stable per row, so this skips needless re-renders.
export const BookieImage = React.memo(BookieImageBase);
